module.exports = __webpack_public_path__ + "img/redzoneisomanhole.52a4ed52.png";